/**
 * Recipe Campaign - One Side Scroll Takeover Component
 */

import { defineAsyncComponent } from 'vue'; 
import { register } from 'swiper/element';

import { type App } from '~/app';

register();

export default (app: App) => {
    app.logger.debug('[Stockland FE] Initialise Swiper Component');
    app.vueApp.component('swiper', defineAsyncComponent(async () => import("./swiper.vue")));

    console.log('Swiper Component Initialised');
};
